import { CommonModule } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ClaudeConnectRequest, ClaudeConnectService } from './claude-connect.service';

/**
 * Where Claude sends the user to connect: it shows who is asking and as whom, and on approval
 * hands the browser back to Claude with a one-time code. The redirect target was checked by the
 * backend against the client's registered redirect URIs; it is never taken from this page's URL.
 */
@Component({
    selector: 'app-claude-connect',
    templateUrl: './claude-connect.component.html',
    styleUrls: ['./claude-connect.component.scss'],
    standalone: true,
    imports: [CommonModule],
})
export class ClaudeConnectComponent implements OnInit {
    readonly request = signal<ClaudeConnectRequest | null>(null);
    readonly state = signal<'loading' | 'ready' | 'expired' | 'busy' | 'redirecting'>('loading');
    readonly error = signal<string | null>(null);
    private id = '';

    constructor(private route: ActivatedRoute, private service: ClaudeConnectService) {}

    ngOnInit(): void {
        this.id = this.route.snapshot.paramMap.get('id') || '';
        this.service.getRequest(this.id).subscribe({
            next: (request) => {
                this.request.set(request);
                this.state.set('ready');
            },
            error: () => this.state.set('expired'),
        });
    }

    approve(): void {
        this.answer(this.service.approve(this.id));
    }

    deny(): void {
        this.answer(this.service.deny(this.id));
    }

    private answer(call: ReturnType<ClaudeConnectService['approve']>): void {
        if (this.state() !== 'ready') {
            return;
        }
        this.state.set('busy');
        call.subscribe({
            next: ({ redirectUrl }) => {
                this.state.set('redirecting');
                this.navigate(redirectUrl);
            },
            error: (err) => {
                this.error.set(err?.error?.message || 'Er ging iets mis. Start het koppelen opnieuw vanuit Claude.');
                this.state.set('expired');
            },
        });
    }

    /** Separate so a test can see where the browser would go. */
    navigate(url: string): void {
        window.location.assign(url);
    }
}
